<template>
  <div class="mc-container">
    <div v-if="relatedConcepts.loading" class="content">
      <b-loading active :is-full-page="false" />
    </div>
    <mc-error-layout
      v-else-if="relatedConcepts.loadError"
      message="Failed to load related Concepts!"
    />
    <div v-else-if="dataSelected" class="content">
      <div
        v-if="dataSelected.relatedConcepts.length == 0"
        class="wrapper has-text-centered"
      >
        No related concept for this challenge
      </div>
      <div v-else class="topic-concepts tile is-ancestor">
        <div
          v-for="topic in completeData"
          :key="topic.id"
          class="tile is-parent is-vertical"
        >
          <div class="tile is-child">
            <div class="topic-concepts__topic-tile box">
              <span class="title is-6">{{ topic.name }}</span>
            </div>
          </div>
          <div
            v-for="concept in topic.concepts"
            :key="concept.id"
            class="tile is-child"
          >
            <div
              :class="[
                'topic-concepts__concept-tile',
                'box',
                {
                  'topic-concepts__concept-tile__not-attempted': !concept.attempt,
                  'topic-concepts__concept-tile__current': challengeIncludes(
                    concept.id
                  )
                }
              ]"
            >
              <span class="title is-6">{{ concept.name }}</span>
              <span class="topic-concepts__concept-tile__versions">
                {{
                  `v:${concept.attempt ? concept.attempt.version : '-'}/${
                    concept.latestVersion
                  }`
                }}
              </span>
              <b-progress
                v-if="concept.attempt"
                topic-concepts__concept-tile__progress
                :value="concept.attempt.progressPercent"
                show-value
                format="percent"
              >
                {{ concept.attempt.progressPercent }} %
              </b-progress>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="wrapper has-text-centered">
      Select a challenge or class to see related concepts info.
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

function calcAttemptInfo({ progress, versionedConceptId }) {
  return !progress
    ? null
    : {
        noOfSteps: progress.length,
        progressPercent:
          progress.reduce((tSum, stepProgress) => {
            switch (stepProgress.type) {
              case 'video':
                return tSum + (stepProgress.completed ? 100 : 0);
              case 'test':
                return (
                  tSum +
                  stepProgress.questions.reduce(
                    (qSum, question) => qSum + (question.completed ? 100 : 0),
                    0
                  ) /
                    stepProgress.questions.length
                );
              default:
                return tSum;
            }
          }, 0) / progress.length,
        version: versionedConceptId.split('_')[1]
      };
}

export default {
  methods: {
    challengeIncludes(conceptId) {
      return this.relatedConcepts.challenge.relatedConcepts.some(
        concept => concept.id == conceptId
      );
    }
  },
  computed: {
    ...mapState(['relatedConcepts']),
    dataSelected() {
      return this.relatedConcepts.userId && this.relatedConcepts.challenge;
    },
    completeData() {
      return Object.keys(this.relatedConcepts.concepts).map(
        (topicId, index) => ({
          id: topicId,
          name: this.relatedConcepts.challenge.relatedTopics[index]['name'],
          concepts: this.relatedConcepts.concepts[topicId].map(concept => ({
            id: concept.id,
            name: concept.name,
            latestVersion: concept.version,
            attempt: calcAttemptInfo(
              this.relatedConcepts.conceptAttempts[
                `${concept.id}_${this.relatedConcepts.userId}`
              ] || {}
            )
          }))
        })
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/initial-variables.sass';

.wrapper {
  margin: 0.4rem;
}

.topic-concepts {
  margin: 0rem;
  .tile {
    &.is-parent {
      padding: 0.4rem;
    }
    &.is-child {
      -webkit-box-flex: 0;
      -ms-flex: none;
      flex: none;
      &:not(:last-child) {
        margin-bottom: 0.5rem !important;
      }
    }
  }

  &__topic-tile,
  &__concept-tile {
    max-width: 20rem;
  }

  &__concept-tile {
    min-height: 6rem;
    position: relative;
    .title {
      font-weight: 300;
      display: block;
    }
    &__not-attempted {
      background-color: $grey-lighter;
      color: $black;
      .title {
        color: $black;
      }
    }

    &__current {
      border: 2px solid $secondary-color;
    }

    &__versions {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 0.75rem;
      font-weight: 600;
      line-height: 1.125;
      background-color: $secondary-color;
      padding: 0.1rem;
    }

    &__progress {
      display: block;
      width: auto;
    }
  }
}
</style>
